import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Logo from '../../assets/logo.png';

import './converter.styles.scss';

import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';

import InfoIcon from '@material-ui/icons/Info';

import CustomisedTabs from '../../components/customised-tabs/customised-tabs.component';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  toolbar: {
    background: '#3c8dbc',
  },
  title: {
    flexGrow: 1,
    marginLeft: 16,
  },
}));

export default function ConverterPage() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className={classes.root}>
      <AppBar position='static'>
        <Toolbar className={classes.toolbar}>
          <Avatar src={Logo} alt='logo' />
          <Typography variant='h6' className={classes.title}>
            Unit Converter
          </Typography>
          <Button
            color='inherit'
            startIcon={<InfoIcon />}
            onClick={handleClickOpen}
          >
            About
          </Button>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby='alert-dialog-title'
            aria-describedby='alert-dialog-description'
          >
            <DialogTitle id='alert-dialog-title'>
              {'Converter app made by OLWG'}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id='alert-dialog-description'>
                Version: 0.1
              </DialogContentText>
            </DialogContent>
          </Dialog>
        </Toolbar>
      </AppBar>
      <CustomisedTabs />
    </div>
  );
}
